import { render, staticRenderFns } from "./dui-file-upload.vue?vue&type=template&id=56ed086f&"
import script from "./dui-file-upload.vue?vue&type=script&lang=js&"
export * from "./dui-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./dui-file-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports